import * as consultationPackageFormNames from "./consultationPackagesFormNames";

export const consultationPackageInitialValues = {
  [consultationPackageFormNames.CODE_PACKAGE_FORM_NAME]: "",
  [consultationPackageFormNames.ROLE_OPERATEUR_FORM_NAME]: "",
  [consultationPackageFormNames.STATUS_PACKAGE_FORM_NAME]: "",
  [consultationPackageFormNames.TYPE_PAIEMENT_FORM_NAME]: "",
  [consultationPackageFormNames.TRANSACTION_AUTORISEE_FORM_NAME]: "",
  [consultationPackageFormNames.NOMBRE_TRANSACTIONS_FORM_NAME]: "",
  [consultationPackageFormNames.TYPE_FRAIS_SERVICE_PACKAGE_FORM_NAME]: "",
};
